const trimEnv = (value) => (typeof value === 'string' ? value.trim() : '');
const applyCorsFlag = trimEnv(process.env.REACT_APP_APPLY_CORS).toLowerCase();
const isDevelopment = process.env.NODE_ENV !== 'production';

const safeUrl = (value) => {
  try {
    return new URL(value);
  } catch {
    return null;
  }
};

const toOrigin = (value) => {
  const trimmed = trimEnv(value);
  if (!trimmed) return '';
  return safeUrl(trimmed)?.origin || trimmed.replace(/\/$/, '');
};

const shouldApplyBrowserCors = !isDevelopment || applyCorsFlag !== 'false';

const inferBridgeOrigin = () => {
  if (typeof window === 'undefined') {
    return 'http://localhost:4000';
  }

  const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
  const hostname = window.location.hostname || 'localhost';
  const port = trimEnv(process.env.REACT_APP_BRIDGE_PORT) || '4000';

  return `${protocol}//${hostname}:${port}`;
};

const appApiBase = trimEnv(process.env.REACT_APP_API_BASE);
const appApiOrigin = toOrigin(appApiBase);
const asteriskApiOrigin = toOrigin(process.env.REACT_APP_ASTERISK_API_BASE);
const resolvedBridgeOrigin = (
  toOrigin(process.env.REACT_APP_BRIDGE_ORIGIN) ||
  asteriskApiOrigin ||
  inferBridgeOrigin()
).replace(/\/$/, '');
const currentOrigin =
  typeof window === 'undefined' ? '' : String(window.location.origin || '').replace(/\/$/, '');

export const BRIDGE_ORIGIN = shouldApplyBrowserCors ? resolvedBridgeOrigin : currentOrigin;
export const ASTERISK_API_BASE = shouldApplyBrowserCors
  ? (trimEnv(process.env.REACT_APP_ASTERISK_API_BASE) || `${BRIDGE_ORIGIN}/api`).replace(/\/$/, '')
  : '/api';
export const CHAT_API_BASE = shouldApplyBrowserCors
  ? (trimEnv(process.env.REACT_APP_CHAT_API_BASE) || appApiBase || ASTERISK_API_BASE).replace(/\/$/, '')
  : '/api';
export const TRANSCRIPTION_API_BASE = shouldApplyBrowserCors
  ? (trimEnv(process.env.REACT_APP_TRANSCRIPTION_API_BASE) || ASTERISK_API_BASE).replace(/\/$/, '')
  : '/api';
const rawChatSocketUrl = trimEnv(process.env.REACT_APP_CHAT_SOCKET_URL);
const chatSocketOrigin = toOrigin(rawChatSocketUrl);
const chatSocketLooksLikeApiUrl = /\/api\/?$/i.test(rawChatSocketUrl);
const chatSocketMatchesAppApi =
  Boolean(chatSocketOrigin) &&
  Boolean(appApiOrigin) &&
  chatSocketOrigin === appApiOrigin &&
  Boolean(asteriskApiOrigin) &&
  chatSocketOrigin !== asteriskApiOrigin;
export const CHAT_SOCKET_URL = shouldApplyBrowserCors
  ? (
      (!chatSocketOrigin || chatSocketLooksLikeApiUrl || chatSocketMatchesAppApi)
        ? BRIDGE_ORIGIN
        : chatSocketOrigin
    ).replace(/\/$/, '')
  : BRIDGE_ORIGIN;
